import request from "@/utils/request.js";

// 获取信息变更审核列表
export const selectPageList = (data) => {
  return request({
    url: "/cloud/carChangeApplyEntity/selectPageList",
    method: "post",
    data: data,
  });
};

// 车辆信息变更申请详情查看
export const getDetail = (data) => {
  return request({
    url: "/cloud/carChangeApplyEntity/detail",
    method: "post",
    data: data,
  });
};

export const getAudit = (data) => {
  return request({
    url: "/cloud/carChangeApplyEntity/audit",
    method: "post",
    data: data,
  });
};
